export function useCalculateVolume(lengthCm, widthCm, heightCm) {
  return (lengthCm * widthCm * heightCm) / 1000000;
}
